import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=6d9ad51b&scoped=true&"
import script from "./hot.vue?vue&type=script&lang=ts&"
export * from "./hot.vue?vue&type=script&lang=ts&"
import style0 from "./hot.vue?vue&type=style&index=0&id=6d9ad51b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ad51b",
  null
  
)

export default component.exports